import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getListOfMaintenanceStaff } from 'actions/maintenanceActions';
import { reassignAgentRenewal } from 'components/landlord_app/rent_roll/renewals/store/actions';
import Header from 'components/shared/Header';
import { AccentColor } from 'helpers/AccentColorHelper';
import RaisedButton from 'material-ui/RaisedButton';
import SearchableSelect from 'components/shared/SearchableSelect';
import { getTranslatedString } from 'helpers/i18n';

const ReassignAgent = ({
  isRenewing,
  getListOfMaintenanceStaff,
  propertyAgents,
  propertyID,
  renewalID,
  reassignAgentRenewal,
}) => {
  const [assignedAgent, setAssignedAgent] = useState(null);

  useEffect(
    () => {
      getListOfMaintenanceStaff(propertyID, {
        agents_only: true,
      });
    },
    [getListOfMaintenanceStaff, propertyID]
  );

  const reassignAgent = () => {
    reassignAgentRenewal(renewalID, {
      reassign_to: assignedAgent,
    });
  };

  const onAgentSelect = selectedAgent => {
    if (!selectedAgent) {
      return;
    }

    setAssignedAgent(selectedAgent.value);
  };

  if (!isRenewing) {
    return null;
  }
  return (
    <div>
      <Header name={getTranslatedString('landlordPortal.renewal.reassignAgent.header')} />
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <p>{getTranslatedString('landlordPortal.renewal.reassignAgent.body')}</p>
          <SearchableSelect
            name="assigned_agent"
            data={propertyAgents}
            label={getTranslatedString('landlordPortal.renewal.reassignAgent.selectLabel')}
            fullWidth
            onChange={onAgentSelect}
          />
          <div className="row" style={{ textAlign: 'center' }}>
            <RaisedButton
              label={getTranslatedString('landlordPortal.renewal.reassignAgent.buttonLabel')}
              primary
              onClick={reassignAgent}
              style={{
                backgroundColor: AccentColor(),
                color: 'white',
                borderRadius: '8px',
                marginTop: '10px',
              }}
              disabled={!assignedAgent}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = store => ({
  propertyAgents: store.maintenanceReducer.maintenance,
});

const mapDispatchToProps = {
  getListOfMaintenanceStaff,
  reassignAgentRenewal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReassignAgent);
